import { combineReducers } from 'redux';
import isInSearchAndFilterMode from './isInSearchAndFilterMode';
import previouslyFocusedThreadId from './previouslyFocusedThreadId';
const searchAndFilteringMode = combineReducers({
  isInSearchAndFilterMode,
  previouslyFocusedThreadId
});
export default searchAndFilteringMode;